/*
 * Translation hook. Replaces the old t() / applyTranslations() pair.
 *
 *   const { t, format, lang, toggleLang } = useTranslation();
 *   <h1>{t.appTitle}</h1>
 *   <span>{format(t.liveCounter, { current, total })}</span>
 *
 * `t` is the active-language dictionary (re-rendered reactively when the
 * language changes); `format` fills {placeholder} tokens.
 */

import { useStore } from "../state/store";
import { format, getDict } from "./translations";
import type { TranslationStrings } from "./translations";

export function useTranslation(): {
  t: TranslationStrings;
  format: typeof format;
  lang: ReturnType<typeof useStore.getState>["lang"];
  toggleLang: () => void;
} {
  const lang = useStore((s) => s.lang);
  const toggleLang = useStore((s) => s.toggleLang);
  return { t: getDict(lang), format, lang, toggleLang };
}
